import { markAsRead } from "@api/stores/notifications/markAsRead/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/notifications/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const notifications = {
  getAll: apiPathFunc(pathBase),
  markAsRead,
};
